export class VideoTimeline {
    onThumbnailClick(time: string): void {
        seek_player(time);
    }
}
